import {useAddToCartOffCanvas} from "../../redux/stateHooks";
import {ResourceType} from "../../definitions/types";
import {WarrantiesModel} from "../../models/view/warrantiesModel";
import {WarrantyModel} from "../../models/domain/warrantyModel";

/**
 * Returns the warranties and the warranty given a warranty id for the current off canvas product.
 * @param warrantyId
 * @returns {{warranty: WarrantyModel | undefined; warranties: WarrantyModel[]}}
 * @param warrantyId
 */
export function useOffCanvasWarranty(warrantyId?: number): { productWarranty: WarrantyModel | undefined; warranties: WarrantyModel[]; } {
    // Get the current off canvas product
    const {product} = useAddToCartOffCanvas();
    // Filter out null resources
    const resources: ResourceType[] = (product?.resources ?? []).filter((res): res is ResourceType => res !== null);
    // Get the warranties for the off canvas product
    const warranties =  new WarrantiesModel(resources).warranties;
    // Get the warranty for the given warranty id for the off canvas product
    const warranty = warranties.find(warranty => warranty.id == warrantyId)
    // Return the warranty and warranties
    return {productWarranty: warranty, warranties};
}

